module.exports={render:function (){var _vm=this;
  return _vm._h('div', [_vm._h('div', {
    staticClass: "topbar"
  }, [_vm._h('div', {
    staticClass: "clearfix main-wrap"
  }, [_vm._h('a', {
    staticClass: "pull-left img-back",
    attrs: {
      "href": "javascript:window.history.go(-1)"
    }
  }, ["返回"]), " ", _vm._h('h1', ["建群"]), " ", _vm._h('span', {
    staticClass: "pull-right icon-right orange",
    on: {
      "click": function($event) {
        _vm.saveOrUpdateClass()
      }
    }
  }, ["确定"])]), " ", _vm._h('div', {
    staticClass: "liner"
  })]), " ", _vm._h('div', {
    staticClass: "main-page"
  }, [_vm._h('div', [_vm._h('p', {
    staticClass: "margin-15"
  }, ["红色“*”为必填项，请认真填写。"]), " ", _vm._h('ul', {
    staticClass: "list-group-item tinny"
  }, [_vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('div', {
    staticClass: "clearfix  group-txt"
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, ["群名称："]), _vm._h('i', {
    staticClass: "red must"
  }, ["*"]), " ", _vm._h('span', {
    staticClass: "pull-right gray"
  }, [_vm._h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.className),
      expression: "className"
    }],
    staticClass: "text-right font-14",
    attrs: {
      "type": "text",
      "placeholder": "请输入群名称"
    },
    domProps: {
      "value": _vm._s(_vm.className)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.className = $event.target.value
      }
    }
  })])])]), " ", _vm._h('li', {
    staticClass: "list-group",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showSelectTeacher()
      }
    }
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('a', {
    staticClass: "clearfix group-txt img-more",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, ["编入老师："]), _vm._h('i', {
    staticClass: "red must"
  }, ["*"]), " ", _vm._h('span', {
    staticClass: "pull-right gray margin-x-15"
  }, [_vm._l((_vm.teacherSelectList), function(item) {
    return ["\n                " + _vm._s(item.teacherName) + " \n              "]
  })])])]), " ", _vm._h('li', {
    staticClass: "list-group",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showSelectStudent()
      }
    }
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('a', {
    staticClass: "clearfix group-txt img-more",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, ["编入学生："]), _vm._h('i', {
    staticClass: "red must"
  }, ["*"]), " ", _vm._h('span', {
    staticClass: "pull-right gray margin-x-15"
  }, [_vm._s(_vm.studentSelectList.length) + "人"])])])]), " ", _vm._h('ul', {
    staticClass: "list-group-item primary"
  }, [_vm._l((_vm.studentSelectList), function(item) {
    return _vm._h('li', {
      staticClass: "list-group"
    }, [_vm._h('div', {
      staticClass: "liner"
    }), " ", _vm._h('router-link', {
      staticClass: "group-link clearfix",
      attrs: {
        "to": {
          path: '/student/detail/' + item.studentId
        }
      }
    }, [_vm._h('span', {
      staticClass: "img-wrap small pull-left"
    }, [_vm._h('img', {
      staticClass: "pull-left",
      attrs: {
        "src": item.imageAddress ? item.baseAcessPath + item.imageAddress : _vm.img_default,
        "width": "40",
        "height": "40"
      }
    })]), " ", _vm._h('span', {
      staticClass: "group-txt"
    }, [_vm._h('span', {
      staticClass: "block overhide"
    }, [_vm._h('cite', {
      staticClass: "pull-left"
    }, [_vm._s(item.studentName)]), _vm._h('i', {
      staticClass: "img-sex boy"
    }, ["男"]), " ", (item.typeName) ? _vm._h('cite', {
      staticClass: "gray pull-right"
    }, [_vm._s(item.typeName)]) : _vm._h('cite', {
      staticClass: "orange pull-right"
    }, ["未添加托管服务"]), " "])])])])
  })])])]), " ", _vm._h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isHideGoAddStudent),
      expression: "!isHideGoAddStudent"
    }],
    staticClass: "maskdiv",
    on: {
      "click": function($event) {
        _vm.isHideGoAddStudent = true
      }
    }
  }, [_vm._h('div', {
    staticClass: "popover",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._h('div', {
    staticClass: "pop-wrap text-center"
  }, [_vm._h('p', ["该班级还没有录入过学生信息，是否现在去添加学生？"]), " ", _vm._h('div', {
    staticClass: "liner margin-15"
  }), " ", _vm._h('div', {
    staticClass: "clearfix"
  }, [_vm._h('div', {
    staticClass: "col-xs-6 blue"
  }, [_vm._h('router-link', {
    staticClass: "blue  block",
    staticStyle: {
      "border-right": "1px solid #ddd"
    },
    attrs: {
      "to": {
        'path': '/student/add'
      }
    }
  }, ["去添加"])]), " ", _vm._h('div', {
    staticClass: "col-xs-6 blue"
  }, [_vm._h('a', {
    staticClass: "blue",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isHideGoAddStudent = true
      }
    }
  }, ["以后再说"])])])])])]), " ", " ", _vm._h('dialogStudents', {
    attrs: {
      "isHideSelectStudent": _vm.isHideSelectStudent,
      "studentFirstCharList": _vm.studentList
    },
    on: {
      "close": _vm.closeDialogStudents,
      "selected": _vm.selectedStudent
    }
  }), " ", _vm._h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isHideSelectTeacher),
      expression: "!isHideSelectTeacher"
    }],
    staticClass: "maskdiv",
    on: {
      "click": function($event) {
        _vm.isHideSelectTeacher = true
      }
    }
  }, [_vm._h('div', {
    staticClass: "slider",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._h('strong', {
    staticClass: "tit"
  }, ["关联老师"]), " ", _vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('div', {
    staticClass: "list-group-item tinny"
  }, [_vm._l((_vm.teacherList), function(item) {
    return _vm._h('ul', [_vm._h('li', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          item.isChecked = !item.isChecked
        }
      }
    }, [_vm._h('div', {
      staticClass: "clearfix group-link"
    }, [_vm._h('span', {
      staticClass: "pull-left"
    }, [_vm._s(item.teacherName)]), " ", _vm._h('i', {
      staticClass: "pull-right img-checkbox",
      class: {
        'checked': item.isChecked
      }
    })]), " ", _vm._h('div', {
      staticClass: "liner"
    })])])
  })]), " ", _vm._h('div', {
    staticClass: "text-center"
  }, [_vm._h('a', {
    staticClass: "button button-rounded button-line",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isHideSelectTeacher = true
      }
    }
  }, ["确定"])])])]), " ", _vm._h('div')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.1@vue-loader/lib/template-compiler.js?id=data-v-475279f8!./~/.10.0.1@vue-loader/lib/selector.js?type=template&index=0!./src/views/class/ClassAdd.vue
// module id = 197
// module chunks = 1